export default "__VITE_ASSET__89c32702__"